import { useEffect, useRef } from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import { hasAccessTokenSelector } from '@/redux/auth/selectors';

export function useLogoutHandler(callback: () => Promise<void> | void) {
  const hasToken = useSelector(hasAccessTokenSelector, shallowEqual);
  const previousHasToken = useRef(hasToken);

  useEffect(() => {
    // logout occurs when the user had a token & then they do not
    if (previousHasToken.current && !hasToken) {
      callback();
    }

    previousHasToken.current = hasToken;
  }, [hasToken, callback]);
}
